export default {
  store: {
    state: {
      actions: [],
      fadeOut: false,
      icon: null,
      name: '',
      show: false,
      text: '',
      theme: null,
      template: null,
    },
    actions: {
      SHOW_MODAL: ({ commit }, modal) => commit('ADD_MODAL', { show: true, ...modal }),
      SHOW_MODAL_SUCCESS({ dispatch }, modal) {
        dispatch('SHOW_MODAL', {
          actions: [
            {
              action: 'close',
              theme: 'success',
              label: 'Ok'
            },
          ],
          theme: 'success',
          fadeOut: 2000,
          ...modal,
        })
      },

      CONFIRM({ dispatch }, modal) {
        dispatch('SHOW_MODAL', {
          actions: [
            {
              action: 'close',
              theme: 'neutral',
              label: 'No',
            },
            {
              action: 'confirm',
              theme: 'danger',
              label: 'Yes',
            },
          ],
          theme: 'danger',
          fadeOut: null,
          ...modal,
        })
      },
    },
    mutations: {
      ADD_MODAL(state, modal) {
        Object.assign(state, modal)
      },
      PATCH_MODAL(state, modal) {
        Object.keys(modal).forEach((key) => {
          state[key] = modal[key]
        })
      },
      CLOSE_MODAL(state) {
        state.show = false
      },
    },
    getters: {
      modal: state => state,
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/modals.js